import { StateStorage } from 'zustand/middleware'
import { createStore } from '..'

export interface WalletConnectSession {
  topic: string
  peerMeta: {
    name: string
    url: string
    icons: string[]
    description: string
  }
  namespaces: Record<
    string,
    { chains?: string[]; accounts: string[]; methods: string[]; events: string[] }
  >
  expiry: number
  createdAt: number
}

export interface WalletConnectSessionsStore {
  sessions: Record<string, WalletConnectSession>
  addSession: (session: WalletConnectSession) => void
  updateSession: (topic: string, updates: Partial<WalletConnectSession>) => void
  removeSession: (topic: string) => void
  getSession: (topic: string) => WalletConnectSession | undefined
  getAllSessions: () => WalletConnectSession[]
  clearAllSessions: () => void
}

export const createWalletConnectSessionsStore = (storage: StateStorage) =>
  createStore<WalletConnectSessionsStore>(
    storage,
    (set, get, store) => ({
      sessions: {},
      addSession: (session) => {
        set({
          sessions: {
            ...get().sessions,
            [session.topic]: session,
          },
        })
      },
      updateSession: (topic, updates) => {
        const session = get().sessions[topic]
        if (!session) return

        set({
          sessions: {
            ...get().sessions,
            [topic]: {
              ...session,
              ...updates,
            },
          },
        })
      },
      removeSession: (topic) => {
        const { [topic]: _, ...rest } = get().sessions
        set({ sessions: rest })
      },
      getSession: (topic) => get().sessions[topic],
      getAllSessions: () => Object.values(get().sessions),
      clearAllSessions: () => set({ sessions: {} }),
    }),
    {
      persist: {
        name: 'walletConnectSessions',
        version: 0,
      },
    }
  )
